export default class FileStorageError extends Error {
  constructor(organizationId, uuid, message) {
    super(`Failure while storing file for uuid ${uuid} : ${message}`);
  }
}
